import React from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'react-recompose';

import withCollegeService from '../withCollegeService';
import ArticulationAgreementSystems from './components/articulationAgreementSystems';
import SearchColleges from './components/searchColleges';

const ArticCollegeSystems = withCollegeService(
  ArticulationAgreementSystems,
  'transferInfo.articulationAgreementSystems',
  '',
  {
    value: 'field_he_xfer_artic_sys',
  },
);

const ArticColleges = withCollegeService(
  withProps({
    cyId: 'Premium-Hem-articulationAgreements-Colleges-Container',
    introMessage: 'articulationAgreementCollegesIntro',
    placeholderMessage: 'articulationAgreementCollegesPlaceholder',
  })(SearchColleges),
  'transferInfo.articulationAgreements',
  '',
  {
    value: 'field_he_xfer_artic_agr',
  },
);

const ArticulationAgreements = ({ formatMessage }) => (
  <React.Fragment>
    <ArticCollegeSystems formatMessage={formatMessage} />
    <ArticColleges formatMessage={formatMessage} />
  </React.Fragment>
);
ArticulationAgreements.propTypes = {
  formatMessage: PropTypes.func,
};

export default ArticulationAgreements;
